import {
    apiRequest,
    pensiunskUpdate,
    pensiunskDetail
} from "../../../../../services/adapters/kepegawaian/pensiunskService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", pensiunskUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunskDetail, {
            params: query
        }, true)
    }
}

export default UpdateRepository